<div class="wrapper__headerComponent container my-5">
  <div class="row">
    <div class="d-flex flex-row align-items-start">
      <img
        src="../../../../assets/img/file-alt.svg"
        alt="logo"
        class="img-ico-form" />
      <h2 class="mb-0"  >
        {{ 'tramites.tramite-dnda.titulo' | translate: { proceso: proceso, entidad: entidad } }}
      </h2>
    </div>
  </div>
  <app-recuadro-justino></app-recuadro-justino>
  <div
    [formGroup]="expediente"
    class="wrapper__form container mt-5 border__form">
    <div class="wrapper__form__content">
      <div
        class="d-flex flex-column flex-xl-row align-items-xl-center mb-4 justify-content-between">
        <h4 class="wrapper__form__title mb-0">
          {{ dndaText['tramite-dnda']['expediente'] }}
        </h4>
        <p class="m-0 text3-tipografia-govco wrapper__form__camposObligatory">
          <span class="text-danger">*</span
          >{{ dndaText['campos-obligatorios'] }}
        </p>
      </div>
      <div class="row mb-3">
        <div class="col-md-12">
          <div class="form-group">
            <label for="requestClass" class="form-label text3-tipografia-govco"
              >{{ comunText['clase-solicitud'] }} </label
            ><span class="text-danger"> *</span>
            <select
              formControlName="requestClass"
              class="form-select"
              type="text"
              id="requestClass"
              (change)="onChangeRequestClass($event)">
              <option disabled selected value="">
                {{ dndaText['seleccione-opcion'] }}
              </option>
              <option
                *ngFor="let item of listaClaseSolicitud"
                [value]="item.Id">
                {{ item.Nombre }}
              </option>
            </select>
            <div
              *ngIf="
                expediente.get('requestClass')?.touched &&
                expediente.get('requestClass')?.invalid
              "
              class="invalid-feedback">
              {{ dndaText['tramite-dnda']['clase-solicitud-required'] }}
            </div>
          </div>
        </div>
      </div>
      <!-- Seccion demandante -->
      <div class="row">
        <div
          class="d-flex flex-xl-row align-items-center mb-4 justify-content-between">
          <h4 class="wrapper__form__title mb-0">
            {{ comunText['datos-demandante'] }}
          </h4>
        </div>
      </div>
      <app-persona
        [showTypePerson]="true"
        [personTypeLabel]="'demandante'"
        [countries]="countries"
        [documentTypeList]="documentTypeList"
        [documentTypeListJuridica]="documentTypeListJuridico"
        [dataLogin]="dataUsuario"
        [isDimar]="false"
        (formData)="handleFormDataDemandante($event)"
        [autocompleted]="true"
        [values]="dataDemandante"
        [isApoderado]="false"></app-persona>
      <div
        class="row mb-3"
        *ngIf="
          formDemanding?.data?.tipoDePersona &&
          formDemanding?.data?.tipoDePersona !== ''
        ">
        <div class="col-md-12">
          <div class="form-group">
            <label
              for="actuarConApoderado"
              class="form-label text3-tipografia-govco">
              {{ comunText['utiliza-abogado'] }} </label
            ><span class="text-danger"> *</span>
            <select
              formControlName="actuarConApoderado"
              class="form-select"
              type="text"
              id="actuarConApoderado"
              (change)="onApoderadoChange($event)">
              <option disabled selected value="">
                {{ dndaText['seleccione-opcion'] }}
              </option>
              <option
                *ngFor="let item of opcionesApoderado"
                [value]="item.value">
                {{ item.text }}
              </option>
            </select>
            <div
              *ngIf="
                expediente.get('actuarConApoderado')?.invalid &&
                expediente.get('actuarConApoderado')?.touched
              ">
              <div
                *ngIf="
                  expediente.get('actuarConApoderado')?.errors?.['required']
                "
                class="invalid-feedback">
                {{ dndaText['utiliza-abogado-required'] }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Seccion RL -->
      <div *ngIf="!esPersonaNaturalDemandante">
        <div
          class="d-flex flex-xl-row align-items-center mb-4 justify-content-between">
          <h2 class="wrapper__form__title mb-0">
            {{ dndaText['tramite-dnda']['representante-legal'] }}
          </h2>
        </div>
        <app-persona
          [showTypePerson]="false"
          [countries]="countries"
          [documentTypeList]="documentTypeLegalList"
          (formData)="handleFormDataRepresentanteLegal($event)"
          [autocompleted]="false"
          [isApoderado]="false"
          [values]="dataRepresentante"
          [esRepresentante]="true"></app-persona>
      </div>
      <div *ngIf="actuarConApoderado">
        <div
          class="d-flex flex-xl-row align-items-center mb-4 justify-content-between">
          <h4 class="wrapper__form__title mb-0">
            {{ dndaText['tramite-dnda']['informacion-abogado'] }}
          </h4>
        </div>
        <app-persona
          [showTypePerson]="false"
          [countries]="countries"
          [documentTypeListApoderado]="documentTypeListApoderado"
          (formData)="handleFormDataApoderado($event)"
          [dataLogin]="dataUsuario"
          [autocompleted]="false"
          [values]="dataApoderado"
          [isApoderado]="true"></app-persona>
        <div class="row mb-3">
          <div class="col-md-6">
            <div class="form-group">
              <label
                for="numeroTarjetaProfesional"
                class="form-label text3-tipografia-govco"
                >{{ comunText['tarjeta-profesional'] }}</label
              >
              <input
                type="text"
                class="form-control"
                id="numeroTarjetaProfesional"
                formControlName="numeroTarjetaProfesional"
                placeholder="{{ comunText['tarjeta-profesional'] }}"
                autocomplete="off"/>
              <div
                *ngIf="
                  expediente.get('numeroTarjetaProfesional')?.errors?.[
                    'minlength'
                  ]
                "
                class="invalid-feedback">
                {{
                  dndaText['tramite-dnda'][
                    'numero-tarjeta-profesional-minlength'
                  ]
                }}
              </div>
              <div
                *ngIf="
                  expediente.get('numeroTarjetaProfesional')?.errors?.[
                    'maxlength'
                  ]
                "
                class="invalid-feedback">
                {{
                  dndaText['tramite-dnda'][
                    'numero-tarjeta-profesional-maxlength'
                  ]
                }}
              </div>
              <div
                *ngIf="
                  expediente.get('numeroTarjetaProfesional')?.errors?.[
                    'pattern'
                  ]
                "
                class="invalid-feedback">
                {{
                  dndaText['tramite-dnda']['numero-tarjeta-profesional-pattern']
                }}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label
                for="telefonoApoderado"
                class="form-label text3-tipografia-govco"
                >{{ comunText['telefono'] }}</label
              >
              <input
                type="text"
                class="form-control"
                id="telefonoApoderado"
                formControlName="telefonoApoderado"
                placeholder="{{ comunText['telefono'] }}"
                autocomplete="off"/>
              <div
                *ngIf="
                  expediente.get('telefonoApoderado')?.errors?.['minlength']
                "
                class="invalid-feedback">
                {{ comunText['telefono-minlength'] }}
              </div>
              <div
                *ngIf="
                  expediente.get('telefonoApoderado')?.errors?.['maxlength']
                "
                class="invalid-feedback">
                {{ comunText['telefono-maxlength'] }}
              </div>
              <div
                *ngIf="expediente.get('telefonoApoderado')?.errors?.['pattern']"
                class="invalid-feedback">
                {{ comunText['telefono-pattern'] }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="claseSolicitud && claseSolicitud === demandId">
        <div
          class="d-flex flex-xl-row align-items-center mb-4 justify-content-between">
          <h4 class="wrapper__form__title mb-0">
            {{ comunText['datos-demandado'] }}
          </h4>
        </div>
        <app-persona
          [showTypePerson]="true"
          [personTypeLabel]="'demandado'"
          [countries]="countries"
          [documentTypeList]="documentTypeList"
          [documentTypeListJuridica]="documentTypeListJuridico"
          (formData)="handleFormDataDemandado($event)"
          [autocompleted]="false"
          [isApoderado]="false"
          [values]="dataDemandado"></app-persona>
      </div>
      <div class="row">
        <app-carga-archivos
          *ngIf="visualizarComponenteArchivos"
          [archivosCargados]="archivosCargados"
          [entidadId]="entidadId"
          [idTramite]="idTramite ?? 0"
          (filesEmit)="setFilesFormValue($event)"
          [mostrarTipo]="false"></app-carga-archivos>
          <div class="mt-3 text-muted small d-flex align-items-center">
            <i class="bi bi-info-circle me-2"></i>
            {{ 'copia_envio.peso_actual' | translate:{ peso: pesoArchivos } }}
          </div>
      </div>
    </div>
  </div>
  <!-- ley -->
  <div class="mt-3 p-3 border bg-light" *ngIf="isButtonEnabled() && claseSolicitudDemanda">
    <div class="alert alert-info">
      <p>
        <strong>{{ 'confirmacion_envio.titulo' | translate }}</strong>
          {{ 'confirmacion_envio.mensaje' | translate }}
      </p>
      <p class="fst-italic">
        {{ 'confirmacion_envio.nota' | translate }}
      </p>
    </div>
    <div class="form-check">
      <input
        class="form-check-input"
        type="checkbox"
        id="confirmacionEnvio"
        (change)="onCheckboxChange($event)"
      />
      <label class="form-check-label" for="confirmacionEnvio">
        {{ 'confirmacion_envio.checkbox' | translate }}
      </label>
    </div>
  </div>
  <div *ngIf="confirmacionEnvio && claseSolicitudDemanda" class="border p-4 mt-4 bg-white shadow-sm rounded">
    <h5 class="wrapper__form__title mb-0">
      {{ 'copia_envio.desea_enviar_copia' | translate }}
    </h5>

    <p>
      {{ 'copia_envio.descripcion' | translate:{ correo: correoDemandado, nombre: nombreDemandado } }}
    </p>

    <div class="d-flex gap-2 mt-3">
      <button
        type="button"
        class="btn btn-outline-secondary"
        (click)="rechazarEnvio()"
        [attr.aria-label]="'copia_envio.rechazar' | translate">
        {{ 'copia_envio.rechazar' | translate }}
      </button>

      <button
        type="button"
        class="btn btn-primary"
        (click)="aceptarEnvio()"
        [attr.aria-label]="'copia_envio.aceptar' | translate">
        {{ 'copia_envio.aceptar' | translate }}
      </button>
    </div>

  </div>

  <div class="flex-row d-flex justify-content-end mt-5">
    <button
      class="btn-govco fill-before-btn-govco"
      style="width: 180px; height: 42px"
      (click)="onSubmitSave()"
      [attr.aria-label]="dndaText['botones-envio']['guardar-sin-enviar']">
      {{ dndaText['botones-envio']['guardar-sin-enviar'] }}
    </button>
    <button
      class="btn-govco fill-send-govco ms-2"
      style="width: 180px; height: 42px"
      (click)="onSubmit()"
      [attr.aria-label]="dndaText['botones-envio']['enviar']">
      {{ dndaText['botones-envio']['enviar'] }}
    </button>
  </div>
</div>
